export type VideoSource = { kind: 'iframe'; src: string } | { kind: 'file'; src: string };

/** Interpreta VIDEO_URL: YouTube/Vimeo como embed (sin autoplay) o archivo de video directo. */
export function getVideoSource(url: string): VideoSource | null {
  const value = url.trim();
  if (!value) return null;

  const youtube = value.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (youtube) return { kind: 'iframe', src: `https://www.youtube-nocookie.com/embed/${youtube[1]}?rel=0` };

  const vimeo = value.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return { kind: 'iframe', src: `https://player.vimeo.com/video/${vimeo[1]}` };

  return { kind: 'file', src: value };
}
